module.exports = __webpack_public_path__ + "static/media/resourceful_personality.b10057fb.svg";